import React from 'react';
import { Instagram, Facebook, ArrowRight } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/58ujAQtekwQT37CqH9LFPA/prime_nation_transparent_bg.png';
export function Footer() {
  return <footer className="bg-brand-black pt-16 pb-8 border-t-4 border-brand-gold" data-id="element-38">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        {/* Top Row - 4 Columns */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16 text-center lg:text-left" data-id="element-40">
          {/* Col 1: Brand */}
          <div className="flex flex-col items-center lg:items-start" data-id="element-41">
            <img src={LOGO_URL} alt="Prime Nation" className="h-16 w-auto mb-4 brightness-0 invert object-contain" data-id="element-42" />
            <p className="text-brand-cream/70 text-sm mb-6" data-id="element-43">
              Free Essentials. Real Connection.
            </p>
            <div className="flex gap-4" data-id="element-44">
              <a href="#" className="w-10 h-10 rounded-full border border-brand-gold flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-45">
                <Instagram size={18} data-id="element-46" />
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-brand-gold flex items-center justify-center text-brand-gold hover:bg-brand-gold hover:text-brand-black transition-colors" data-id="element-47">
                <Facebook size={18} data-id="element-48" />
              </a>
            </div>
          </div>

          {/* Col 2: Quick Links */}
          <div data-id="element-49">
            <h4 className="text-brand-gold font-bold tracking-wider uppercase text-sm mb-6" data-id="element-50">
              Quick Links
            </h4>
            <ul className="space-y-3" data-id="element-51">
              {['Home', 'About', 'Services', 'Members', 'Careers', 'Gallery', 'Press', 'Contact'].map(link => <li key={link} data-id="element-52">
                  <a href="#" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-53">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 3: Programs */}
          <div data-id="element-54">
            <h4 className="text-brand-gold font-bold tracking-wider uppercase text-sm mb-6" data-id="element-55">
              Programs
            </h4>
            <ul className="space-y-3" data-id="element-56">
              {['Free Phone', 'Free Tablet', 'Free Internet', 'Free Healthcare', 'Discounted Service'].map(link => <li key={link} data-id="element-57">
                  <a href="#" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-58">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Col 4: Contact */}
          <div data-id="element-59">
            <h4 className="text-brand-gold font-bold tracking-wider uppercase text-sm mb-6" data-id="element-60">
              Contact
            </h4>
            <ul className="space-y-3" data-id="element-61">
              <li data-id="element-62">
                <a href="mailto:no-reply@primenation.com" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-63">
                  no-reply@primenation.com
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="text-brand-cream/70 hover:text-brand-gold transition-colors text-sm" data-id="element-65">
                  Find a Location
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="text-brand-gold font-bold hover:text-yellow-500 transition-colors text-sm flex items-center justify-center lg:justify-start gap-1 mt-4" data-id="element-67">
                  Schedule Appointment <ArrowRight size={14} data-id="element-68" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Newsletter Row */}
        <div className="flex flex-col items-center justify-center mb-16 max-w-md mx-auto" data-id="element-69">
          <h4 className="text-brand-gold font-bold tracking-wider uppercase text-sm mb-4" data-id="element-70">
            Stay Connected
          </h4>
          <form className="flex flex-col sm:flex-row w-full gap-2" onSubmit={e => e.preventDefault()} data-id="element-71">
            <input type="email" placeholder="Enter your email" className="flex-grow bg-white/5 border border-white/10 rounded px-4 py-3 text-white placeholder:text-white/30 focus:outline-none focus:border-brand-gold min-h-[48px]" required data-id="element-72" />
            <button type="submit" className="bg-brand-gold text-brand-black px-6 py-3 rounded font-bold hover:bg-yellow-500 transition-colors min-h-[48px] whitespace-nowrap" data-id="element-73">
              JOIN
            </button>
          </form>
        </div>

        {/* Bottom Strip */}
        <div className="pt-8 border-t border-brand-gold/20 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-74">
          <p className="text-brand-cream/40 text-xs" data-id="element-75">
            © 2026 Prime Nation. All rights reserved.
          </p>
          <div className="flex gap-4 text-brand-cream/40 text-xs" data-id="element-76">
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-77">
              Terms of Use
            </a>
            <span data-id="element-78">|</span>
            <a href="#" className="hover:text-brand-gold transition-colors" data-id="element-79">
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </footer>;
}